import { render } from "./PHome.vue?vue&type=template&id=c6d3f06a&scoped=true"
import script from "./PHome.vue?vue&type=script&lang=js"
export * from "./PHome.vue?vue&type=script&lang=js"

import "./PHome.vue?vue&type=style&index=0&id=c6d3f06a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d3f06a"]])

export default __exports__